/* eslint-disable react/prop-types */
import React from "react";
import App from "next/app";
import { compose } from "@insightfulscience/shared-utils/fn";
import displayName from "@insightfulscience/smart-react/displayName";
import globalContext from "./context";
import withGetInitialProps from "../withGetInitialProps";

const createPageProps = context => ({ pageProps }) => ({
	pageProps: {
		...pageProps,
		contextContainer: {
			context,
			toJSON: () => null,
		},
	},
});

const withGlobalContext = AppComponent => {
	const AppWithGlobalContext = ({ Component, pageProps }) => {
		const { contextContainer = {}, ...props } = pageProps;
		const context = contextContainer?.context;

		return (
			<globalContext.Provider value={context}>
				<AppComponent Component={Component} pageProps={props} />
			</globalContext.Provider>
		);
	};

	AppWithGlobalContext.getInitialProps = appContext =>
		App.getInitialProps(appContext).then(createPageProps(appContext.ctx));

	AppWithGlobalContext.displayName = displayName("withGlobalContext", AppComponent);

	return AppWithGlobalContext;
};

export default compose(withGlobalContext, withGetInitialProps);
